import { render } from "./SchedulesDetailsSetupTab.vue?vue&type=template&id=c6f6c942&scoped=true"
import script from "./SchedulesDetailsSetupTab.vue?vue&type=script&lang=js"
export * from "./SchedulesDetailsSetupTab.vue?vue&type=script&lang=js"

import "./SchedulesDetailsSetupTab.vue?vue&type=style&index=0&id=c6f6c942&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6f6c942"]])

export default __exports__